<section class="tpa-info-banner-component-wrapper">
    <div class="tpa-info-banner-header">
      <mat-icon>
        <!-- "Warning" Icon -->
        <span class="material-icons-outlined">
          lock
        </span>
      </mat-icon>
      <span>Account Expired</span>
    </div>
    <div class="tpa-info-banner-account-name-container">
        <!-- Account Name -->
        <span class="tpa-info-banner-account-name">{{organizationName}}</span>
    </div>
    <div class="tpa-info-banner-message-container">
      <!-- Message -->
      <p class="tpa-info-banner-message">
        You have been expired due to inactivity in this account. 
        Please contact your administrator for further assistance.
      </p>
    </div>
  </section>